export default __webpack_public_path__ + "static/media/jobda_app_logo.335e01aa.svg";